const e = {
  name: "Weight",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.5,10c1-1.1,1.5-2.5,1.5-4c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6c0,1.5,0.6,2.9,1.5,4H6.2L0,40h40l-6.2-30
			H24.5z M16,6c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C17.8,10,16,8.2,16,6z M7.8,12h24.4l5.4,26H2.5L7.8,12z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Weight
};
